import { TranslateService } from '@ngx-translate/core';
import { PasConfirmationService } from '@porsche-aftersales/frontend-toolbox';

export async function confirmNavbarTabChangeDialog(
  translateService: TranslateService,
  pasConfirmationService: PasConfirmationService,
): Promise<boolean> {
  let result: Promise<any>;

  translateService
    .get(['FORM_CONTAINS_UNSAVED_DATA_TITLE', 'FORM_CONTAINS_UNSAVED_DATA_MESSAGE', 'OK', 'CANCEL'])
    .subscribe((translate: { [key: string]: any }) => {
      const title: string = translate.FORM_CONTAINS_UNSAVED_DATA_TITLE;
      const message: string = translate.FORM_CONTAINS_UNSAVED_DATA_MESSAGE;
      const ok: string = translate.OK;
      const dismiss: string = translate.CANCEL;

      result = pasConfirmationService.showConfirmation(title, message, ok, dismiss, false).then(
        () => true,
        () =>
          // stay where you are and do nothing, close information dialog
          false,
      );
    });
  return result;
}
